import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getCalcMethods, saveCalcMethodsBatch } from '../../api/calcMethods';
import type { CalcMethod } from '../../types/CalcMethod';
import { t } from '../../i18n/t';

const calcMethodsColumnDefs: ColDef<CalcMethod>[] = [
  {
    field: 'calcMethodId',
    headerName: t('calcMethods.columns.calcMethodId'),
    width: 110,
    // Natural PK: editable on Add only.
    editable: (params: EditableCallbackParams<CalcMethod>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'calcTypeId',
    headerName: t('calcMethods.columns.calcTypeId'),
    width: 110,
    editable: true,
    cellDataType: 'number',
  },
  {
    field: 'calcMethodCode',
    headerName: t('calcMethods.columns.calcMethodCode'),
    width: 220,
    editable: true,
  },
  {
    field: 'calcMethodName',
    headerName: t('calcMethods.columns.calcMethodName'),
    width: 280,
    editable: true,
  },
  {
    field: 'calcMethodDetails',
    headerName: t('calcMethods.columns.calcMethodDetails'),
    flex: 1,
    editable: true,
  },
];

const newCalcMethodDefaults = (): Partial<CalcMethod> => ({
  calcMethodId: 0,
  calcTypeId: 2,
  calcMethodCode: '',
  calcMethodName: '',
  calcMethodDetails: null,
});

export function CalcMethodsPage() {
  return (
    <LopCrudPage<CalcMethod>
      resourceCode="calcMethods"
      titleKey="calcMethods.pageTitle"
      idField="calcMethodId"
      getRows={getCalcMethods}
      saveBatch={(added, modified, deletedIds) =>
        saveCalcMethodsBatch(added, modified, deletedIds as number[])
      }
      columnDefs={calcMethodsColumnDefs}
      newRowDefaults={newCalcMethodDefaults}
    />
  );
}
